import { Stack } from '@mui/material';
import { memo } from 'react';
import PrimaryButton from './PrimaryButton';

const ActionButtons = ({
  clearLabel,
  generateLabel,
  onClear,
  onGenerate,
  disableGenerate = false,
  disableClear = false,
}) => (
  <Stack direction="row" spacing={1.5} justifyContent="flex-end">
    <PrimaryButton label={clearLabel} onClick={onClear} disabled={disableClear} />
    <PrimaryButton label={generateLabel} onClick={onGenerate} disabled={disableGenerate} />
  </Stack>
);

export default memo(ActionButtons);
